import React from 'react';
import { Shield, Building2, Users, Award } from 'lucide-react';

const companies = [
  { name: 'BuildRight Construction', industry: 'Construction' },
  { name: 'Pacific Manufacturing', industry: 'Manufacturing' },
  { name: 'LogiFreight Inc.', industry: 'Logistics' },
  { name: 'SafeWorks Industrial', industry: 'Industrial' },
  { name: 'Premier Healthcare', industry: 'Healthcare' },
  { name: 'Atlantic Energy', industry: 'Energy' }
];

const SocialProof = () => {
  return (
    <section className="py-12 bg-slate-900">
      <div className="container mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          {/* Stats */}
          <div className="flex flex-wrap justify-center md:justify-start gap-8">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-xl bg-emerald-500/20 flex items-center justify-center">
                <Users className="w-6 h-6 text-emerald-400" />
              </div>
              <div>
                <div className="text-2xl font-bold text-white">8,500+</div>
                <div className="text-sm text-slate-400">Workers Trained</div>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-xl bg-emerald-500/20 flex items-center justify-center">
                <Building2 className="w-6 h-6 text-emerald-400" />
              </div>
              <div>
                <div className="text-2xl font-bold text-white">500+</div>
                <div className="text-sm text-slate-400">Companies</div>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-xl bg-emerald-500/20 flex items-center justify-center">
                <Award className="w-6 h-6 text-emerald-400" />
              </div>
              <div>
                <div className="text-2xl font-bold text-white">98%</div>
                <div className="text-sm text-slate-400">Pass Rate</div>
              </div>
            </div>
          </div>

          {/* Company logos placeholder */}
          <div className="text-center md:text-right">
            <p className="text-slate-400 text-sm mb-3">Trusted by industry leaders</p>
            <div className="flex flex-wrap justify-center md:justify-end gap-4">
              {companies.slice(0, 4).map((company, i) => (
                <div 
                  key={i} 
                  className="px-4 py-2 bg-slate-800 rounded-lg border border-slate-700 text-slate-300 text-sm font-medium"
                >
                  {company.name.split(' ')[0]}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SocialProof;
